var External = require("./Constructors").External;
var reduce = require("./Reductions").reduce;

/**
 * reduceLambdaObject(obj, reduction) is based on `reduce`.
 * The key difference is that it processes a lambda object
 *   and never returns undefined.
 * If `obj.term` is reduced to External object, unwrapped `object` is returned.
 * Otherwise a lambda object with reduced term is returned.
 * @param obj - a lambda object
 * @param reduction - a specification of reduction, @see reduce
 * @return a lambda object or an `object` of External
 * @see reduce
 * @memberof module:Lambda/reduceLambdaObject
 */
function reduceLambdaObject(obj, reduction) {
  if(!obj || obj.type !== "Lambda") {
    return obj;
    /*
    console.error("Lambda object expected");
    console.warn(obj);
    throw "Lambda object expected, but " + obj + " found";
    */
  }
  if(obj.value !== undefined) return { type: "Lambda", term: obj.value };
  var term = reduce(obj.term, reduction);
  if(term === undefined) term = obj.term;
  if(term instanceof External) {
    if(term.object.type == "Lambda") return reduceLambdaObject(term.object);
    return term.object;
  }
  obj.value = term;
  return { type: "Lambda", term: term };
}

module.exports = reduceLambdaObject;
